<template>
  <div class="animated fadeIn list-of-arreport">
    <b-card>
      <div slot="header">HISTORY TRANSACTION CUSTOMER 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><label style="width:80px;">Customer</label></b-input-group-prepend>
                <b-form-input readonly v-model="filter.custinfo" ></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col md="2">
            <b-input-group >
                <b-input-group-prepend><span class="input-group-text">Currency</span></b-input-group-prepend>
                <b-form-select v-model="filter.matauang" :plain="true" :options="currency" ></b-form-select>
            </b-input-group>
        </b-col>
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><span class="input-group-text">As of Date</span></b-input-group-prepend>
                <b-form-input v-model="filter.tgl2" type="date" placeholder="until date"></b-form-input>
                <b-form-checkbox  class="mt-2 ml-2" v-model="filter.alltrx" value=1 unchecked-value=0>Include Old/Closed Invoices</b-form-checkbox>
            </b-input-group>
        </b-col>
        <b-col md="2">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table style="width: 100%;">
              <thead>
                  <tr>
                    <th width="90px">Trx. Date</th>
                    <th width="110px">AR Invoice#</th>
                    <th width="110px">PO. Number</th>
                    <th width="110px">Pay. Number</th>
                    <th width="110px">Pay. Method</th>
                    <th>Description</th>
                    <th width="40px">Pay. Type</th>
                    <th width="40px">$,¥</th>
                    <th width="110px" style="text-align:right">Debit</th>
                    <th width="50px" v-if="(showCancelFlag=='Hide')">FLAG</th>
                    <th width="110px" style="text-align:right">Credit</th>
                    <th width="110px" style="text-align:right">Outstand</th>
                    <th width="60px" style="text-align:right">Age (days)</th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="row in rptLines" :key="row.tablekey">
                    <td :class="row.kelas"><span v-if="row.tanggal"> {{row.tanggal | moment("DD MMM YYYY")}}</span></td>
                    <td :class="row.kelas">{{row.invoice}}</td>
                    <td :class="row.kelas">{{row.po}}</td>
                    <td :class="row.kelas">{{row.nomor}}</td>
                    <td :class="row.kelas">{{row.paymethod}}</td>
                    <td :class="row.kelas">{{row.uraian}}</td>
                    <td :class="row.kelas">{{row.pack_name}}</td>
                    <td :class="row.kelas">{{row.matauang}}</td>
                    <td  :class="row.kelas" style="text-align:right"><span v-if="(row.ttlamtdue)">{{row.ttlamtdue | numFormat}}</span></td>
                    <td class="cancelflag" v-if="((showCancelFlag=='Hide') && (row.ttlamtdue==row.outstand) && (row.invoice))"> <b-form-checkbox v-model="row.cancelflag" :value="1" :unchecked-value="0" @change="calcTotalCancelReissue($event)"></b-form-checkbox></td>
                    <td  :class="row.kelas" style="text-align:right"><span v-if="(row.nilaibayar)">{{row.nilaibayar | numFormat}}</span></td>
                    <td  :class="row.kelas" style="text-align:right">{{row.outstand | numFormat}}</td>
                    <td  :class="row.kelas" style="text-align:right">{{row.aging}}</td>
                </tr>
                <tr>
                    <td class="tebal" style="text-align:right" colspan="7">SUB TOTAL : &nbsp;</td>
                    <td class="total" style="text-align:right"></td>
                    <td class="total" style="text-align:right">{{subtotal.debit | numFormat}}</td>
                    <td class="cancelflag" v-if="(showCancelFlag=='Hide')" style="text-align:right">{{totalCancelReissue | numFormat}}</td>
                    <td class="total" style="text-align:right">{{subtotal.credit | numFormat}}</td>
                    <td class="total" style="text-align:right">{{subtotal.outstand | numFormat}}</td>
                </tr>
              </tbody>
          </table>
      </div>
        <b-row  class="mt-2">
            <b-col cols="6">
            <b-form-checkbox v-model="showCancelFlag" name="check-button"  value="Hide" unchecked-value="Show" switch>
                <b> {{ showCancelFlag }}</b> selection flag for a couple of Invoice & Cancelation
            </b-form-checkbox>
            </b-col>
            <b-col cols="6">
                <b-button v-if="(showCancelFlag=='Hide')" class="btn btn-success" @click="saveCancelReissue()" > <i class="fa fa-save"></i> Save Cancelation & Reissue Couples</b-button>                
            </b-col>
        </b-row>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }

            td.payment {
                font-style: italic;
                background-color: rgba(0, 0, 0, 0.05) !important;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
                height: 40px;
            }

            td.cancelflag {
                color: white !important;
                background: #5cb85c !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }
        }

    }
 
</style>

<script>
import moment from 'moment';
import arreport from "../../apis/arreport";
import lkuCustomer from "../lookup/lkuCustomer";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        customer: { required },
        matauang: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      showCancelFlag:'Show',
      totalCancelReissue:0,
      lkuCustomerShow:false,
      reportUrl: null,
      filter: {customer:'',matauang:this.$store.state.user.matauang, tgl2:'', alltrx:0},
      currency: [],
      rptLines : [],
      subtotal :{debit: 0, credit:0 , outstand:0}
    };
  },
  components: {Loading,lkuCustomer},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },  
  created: async function(){
        this.currency = await arreport.currency();
    //   const matauang = await arreport.currency();
    //   this.currency = matauang.reduce((newArr,item) =>{
    //         newArr.push(item);
    //         return newArr;
    //     },[{ value: '', text: '-ALL-'}]);

        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.filter.tgl1=this.$store.state.user.tglaktif;
        this.filter.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.filter.custinfo = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.filter.customer = _selected.CustCode;
        this.filter.customer_id = _selected.customer_id;
        this.lkuCustomerShow=false;
    },

    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.showCancelFlag='Show';
        this.isLoading=true;
        const result = await arreport.trxcustomer(this.filter);   
        if (result.success) {
            this.rptLines = result.data[0];   
            this.subtotal = result.data[2];
        } else {
          toastr.error(result.message,'ERROR',10000);
        }

        this.isLoading=false;      
       }
    },
    calcTotalCancelReissue: function(evt) {
        setTimeout(() => {
            this.totalCancelReissue= this.rptLines.reduce((tot, item) => {
                if ((item.cancelflag === 1) && (item.ttlamtdue===item.outstand)) {
                    tot +=  parseInt(item.ttlamtdue || 0);
                }
                return tot;
            }, 0);
            
        }, 500);
    },
    saveCancelReissue: async function() {
            this.totalCancelReissue= this.rptLines.reduce((tot, item) => {
                if ((item.cancelflag === 1) && (item.ttlamtdue===item.outstand)) {
                    tot +=  parseInt(item.ttlamtdue || 0);
                }
                return tot;
            }, 0);
        if (this.totalCancelReissue !== 0) {
            toastr.error("Total of Cancelation(-) & Reissue(+) couples have to be 0 (ZERO)");
        } else {
            const arrCouple= this.rptLines.reduce((arr, item) => {
                if ((item.cancelflag === 1) && (item.ttlamtdue===item.outstand)) {
                    arr.push(item);
                }
                return arr;
            }, []);
            if (arrCouple.length>1) {
                this.isLoading=true;
                try {
                    await arreport.saveCancelReissue({tgl2:this.filter.tgl2,arrCouple});      
                    toastr.success(`Complete Successfully`, "Save couple of Invoice & Cancelation",10000);
                    this.showCancelFlag=='Show'
                } catch (error) {
                    if (error.message) {
                        toastr.error(error.message);
                    } else {
                        toastr.error(JSON.stringify(error));
                    }                
                }
                this.isLoading=false;      
            }
        }
    },
    printJv: async function(data){
        this.showConfirmAction=false;
        this.showList=false;
       if ((data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await arreport.printjv(data);
              this.isLoading=false;    
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.showReport=true;
                this.reportUrl= await arreport.trxcustomerprint(this.filter);
                this.isLoading=false;    
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await arreport.trxcustomerexport(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
